/* v60d (2026-05-07): Świeczka cyferka digit picker.
   Replaces the legacy free-text candle input with a stock-aware digit grid.
   - Fetches /products/swieczka-cyferka.js to learn current inventory
   - Disables out-of-stock and low-stock-exhausted digits
   - Tracks selections in window.__batidaCandleSelections (array of digits)
   - Mirrors selections into the legacy .cross-product__input-text--candles
     input so existing systems keep working (FoodSoft etc.)
   - Cooperates with batida-drawer.js v60d collectCrossProducts changes
     which read window.__batidaCandleVariantMap to add one line item
     per digit using the correct variant ID.
   - BS-13 (2026-05-31): single source of truth `selItems` ([{id,digit}]).
     Chip removal resolves the clicked chip's stable id against selItems, never
     a render-time index, so wrong-removal is structurally impossible.
     window.__batidaCandleSelections is a DERIVED flat digit array (same
     reference, rebuilt in place) — drawer/FoodSoft contract unchanged. */
(function(){
if (window.__batidaCandlePickerLoaded) return;
window.__batidaCandlePickerLoaded = true;

var CANDLE_HANDLE = 'swieczka-cyferka';
var variantMap = null;
var pricePerCandle = 7.90;

/* BS-13: `selItems` is the authoritative list of { id, digit } in click order.
   `selections` is a DERIVED flat digit array exposed on window for the drawer;
   it is rebuilt in place (same array reference) by syncExposed() on every
   change, so batida-drawer.js v60d keeps reading the same object. Removal
   always works off selItems by stable id, so no external mutation of the
   exposed flat array can ever delete the wrong digit. */
var selItems = [];
var __selSeq = 0;
var selections = [];
window.__batidaCandleSelections = selections;
window.__batidaCandleVariantMap = null;

function syncExposed(){
  selections.length = 0;
  for (var i = 0; i < selItems.length; i++) selections.push(selItems[i].digit);
}

function getLang(){
  return ((document.documentElement.lang || 'pl').toLowerCase().split('-')[0]) || 'pl';
}

/* v75 (2026-05-08): inline 5-lang DICT replaced with window.batidaT bridge → locales/pl.json. snake_case keys. */
var DICT_PL = {
  choose:        window.batidaT('candle_picker.choose',        'Wybierz cyferki'),
  each:          window.batidaT('candle_picker.each',          'Każda cyferka'),
  your:          window.batidaT('candle_picker.your',          'Wybór:'),
  out:           window.batidaT('candle_picker.out',           'brak'),
  pieces:        window.batidaT('candle_picker.pieces',        'szt.'),
  in_set:        window.batidaT('candle_picker.in_set',        'w zestawie'),
  candle:        window.batidaT('candle_picker.candle',        'świeczka'),
  candles:       window.batidaT('candle_picker.candles',       'świeczki'),
  candles_many:  window.batidaT('candle_picker.candles_many',  'świeczek'),
  clear_tooltip: window.batidaT('candle_picker.clear_tooltip', 'Usuń')
};

function t(key){
  return DICT_PL[key] || '';
}

function pluralCandle(n){
  var lang = getLang();
  if (lang === 'pl' || lang === 'uk') {
    if (n === 1) return t('candle');
    if (n >= 2 && n <= 4) return t('candles');
    return t('candles_many');
  }
  return n === 1 ? t('candle') : t('candles');
}

function fmtPrice(n){
  /* 29.09: the site-wide price helper (layout/theme.liquid) - "7,90 zł" in every language, like the Liquid prices */
  if (window.batidaMoney) return window.batidaMoney(Math.round(n * 100));
  var s = (Math.round(n*100)/100).toFixed(2);
  if (getLang() === 'pl' || getLang() === 'uk' || getLang() === 'de' || getLang() === 'fr') {
    s = s.replace('.', ',');
  }
  return s + ' zł';
}

function fetchVariants(){
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var localizedHandle = CANDLE_HANDLE;
  var cp = findCandleCp();
  if (cp) {
    var m = (cp.className || '').match(/cross-product--(\S+)/);
    if (m && m[1]) localizedHandle = m[1];
  }
  var url = root.replace(/\/$/, '') + '/products/' + localizedHandle + '.js';
  return fetch(url, {credentials: 'same-origin'}).then(function(r){
    if (!r.ok) throw new Error('candle product fetch failed: ' + r.status + ' for ' + url);
    return r.json();
  });
}

function buildVariantMap(productData){
  var map = {};
  (productData.variants || []).forEach(function(v){
    var digit = (v.option1 || v.title || '').toString().trim();
    if (/^[0-9]$/.test(digit)) {
      map[digit] = {
        id: v.id,
        available: !!v.available,
        qty: (typeof v.inventory_quantity === 'number' && v.inventory_quantity >= 0)
              ? v.inventory_quantity
              : (v.available ? 999 : 0)
      };
    }
  });
  if (productData.price) pricePerCandle = productData.price / 100;
  return map;
}

function findCandleCp(){
  var cps = document.querySelectorAll('.cross-product');
  for (var i = 0; i < cps.length; i++) {
    var cp = cps[i];
    if (cp.getAttribute('data-canonical-handle') === CANDLE_HANDLE) return cp;
    if ((cp.className || '').indexOf('cross-product--' + CANDLE_HANDLE) !== -1) return cp;
  }
  return null;
}

function findExpandedPanel(cp){
  /* v60d-fix (2026-05-07): the v29 PDP layout puts cross-products and
     their input panels in DIFFERENT .batida-perso-expanded containers,
     so cp.parentElement.nextElementSibling doesn't reach the input.
     Locate the panel by finding the legacy candles input directly —
     that's the place where the picker should live (replacing the input). */
  /* BS-33 (2026-05-30): on localized (EN/etc.) storefronts the v29 perso-card
     relocation can lag, so an early call would find the candles input still
     inside the hidden .cross-products SOURCE and mount the picker there
     (0×0, ATC disabled — the EN number-candle race). Prefer the input that has
     been relocated OUT of .cross-products; if only the source copy exists yet,
     return null so init() keeps retrying until relocation completes. */
  var inputs = document.querySelectorAll('.cross-product__input-text--candles');
  var legacy = null;
  for (var i = 0; i < inputs.length; i++) {
    if (!inputs[i].closest('.cross-products')) { legacy = inputs[i]; break; }
  }
  if (legacy) {
    var panel = legacy.closest('.batida-perso-expanded');
    if (panel) return panel;
    var wrap = legacy.closest('.cross-product__input-wrapper');
    if (wrap && wrap.parentElement) return wrap.parentElement;
  }
  return null;
}

function countDigit(digit){
  var n = 0;
  for (var i = 0; i < selItems.length; i++) if (selItems[i].digit === digit) n++;
  return n;
}

function canAdd(digit){
  if (!variantMap || !variantMap[digit]) return false;
  var v = variantMap[digit];
  if (!v.available) return false;
  return countDigit(digit) < v.qty;
}

function buildPickerHTML(){
  var html = '<div class="batida-candle-picker" data-batida-candle-picker>';
  html += '<div class="batida-candle-picker__header">';
  html += '<span class="batida-candle-picker__title">' + t('choose') + '</span>';
  html += '<span class="batida-candle-picker__subtitle">' + t('each') + ' ' + fmtPrice(pricePerCandle) + '</span>';
  html += '</div>';
  html += '<div class="batida-candle-picker__preview" data-batida-candle-preview></div>';
  html += '<div class="batida-candle-picker__grid">';
  for (var d = 0; d <= 9; d++) {
    var ds = String(d);
    var v = variantMap[ds] || {available: false, qty: 0};
    html += '<button type="button" class="batida-candle-picker__tile" data-batida-candle-digit="' + ds + '">';
    html += '<span class="batida-candle-picker__digit">' + ds + '</span>';
    html += '<span class="batida-candle-picker__sub" data-batida-candle-sub></span>';
    html += '</button>';
  }
  html += '</div>';
  html += '<div class="batida-candle-picker__total">';
  html += '<span data-batida-candle-count></span>';
  html += '<span data-batida-candle-price></span>';
  html += '</div>';
  html += '</div>';
  return html;
}

function updateUI(panel){
  var preview = panel.querySelector('[data-batida-candle-preview]');
  if (preview) {
    var html = '<span class="batida-candle-picker__preview-label">' + t('your') + '</span>';
    if (selItems.length === 0) {
      html += '<span class="batida-candle-picker__preview-empty">…</span>';
    } else {
      selItems.forEach(function(it){
        /* BS-13: stamp the stable selection id (not the array index) so the
           click handler resolves the digit by identity, not rendered position. */
        html += '<span class="batida-candle-picker__chip" data-batida-candle-id="' + it.id + '">';
        html += '<span class="batida-candle-picker__chip-d">' + it.digit + '</span>';
        html += '<span class="batida-candle-picker__chip-x" title="' + t('clear_tooltip') + '">×</span>';
        html += '</span>';
      });
    }
    preview.innerHTML = html;
  }

  var count = panel.querySelector('[data-batida-candle-count]');
  var priceEl = panel.querySelector('[data-batida-candle-price]');
  if (count) count.textContent = selItems.length + ' ' + pluralCandle(selItems.length) + ' ' + t('in_set');
  if (priceEl) priceEl.textContent = fmtPrice(selItems.length * pricePerCandle);

  panel.querySelectorAll('[data-batida-candle-digit]').forEach(function(tile){
    var d = tile.getAttribute('data-batida-candle-digit');
    var v = variantMap[d] || {available:false, qty:0};
    var sel = countDigit(d);
    var atCap = sel >= v.qty;
    var disabled = !v.available || v.qty === 0 || atCap;

    tile.classList.toggle('batida-candle-picker__tile--selected', sel > 0);
    tile.classList.toggle('batida-candle-picker__tile--disabled', disabled);
    tile.classList.toggle('batida-candle-picker__tile--low-stock', v.available && v.qty > 0 && v.qty <= 2 && sel === 0);
    tile.disabled = disabled;

    var sub = tile.querySelector('[data-batida-candle-sub]');
    if (sub) {
      if (!v.available || v.qty === 0) sub.textContent = t('out');
      else if (sel > 0) sub.textContent = '×' + sel;
      else if (v.qty <= 2) sub.textContent = v.qty + ' ' + t('pieces');
      else sub.textContent = '';
    }
  });

  var legacy = panel.querySelector('.cross-product__input-text--candles');
  if (legacy) {
    var newVal = selections.join('');
    if (legacy.value !== newVal) {
      legacy.value = newVal;
      /* BS-32: the legacy custom.js candles 'change' handler toggles " x2" on
         .cross-product__label-candles via $(...).html().replace(...). On the v2
         card that label element doesn't exist, so .html() is undefined and
         .replace throws an intermittent uncaught TypeError on the conversion
         page. Fire the bubbling 'change' only when the label is present (legacy
         DOM where the handler is safe); otherwise skip it — the candles-quantity
         field is set directly below, so nothing else depends on this event.
         (The old bubbling 'input' dispatch was dead: the only 'input' sanitizer
         is bound directly to #bp_text, which a candles-field event never reaches.) */
      if (document.querySelector('.cross-product__label-candles')) {
        try { legacy.dispatchEvent(new Event('change', {bubbles: true})) } catch(e){}
      }
    }
  }
  var hidden = panel.querySelector('.cross-product__input--candles-quantity');
  if (hidden) hidden.value = selItems.length;
}

function wirePicker(panel){
  if (panel.getAttribute('data-batida-candle-wired') === '1') return;
  panel.setAttribute('data-batida-candle-wired', '1');
  panel.addEventListener('click', function(e){
    var tile = e.target.closest('[data-batida-candle-digit]');
    if (tile && !tile.disabled) {
      var d = tile.getAttribute('data-batida-candle-digit');
      if (canAdd(d)) {
        selItems.push({ id: ++__selSeq, digit: d });   /* BS-13: append to source of truth */
        syncExposed();
        updateUI(panel);
      }
      e.preventDefault();
      return;
    }
    var x = e.target.closest('.batida-candle-picker__chip-x');
    if (x) {
      var chip = x.closest('[data-batida-candle-id]');
      if (chip) {
        var sid = parseInt(chip.getAttribute('data-batida-candle-id'), 10);
        /* BS-13: resolve the clicked chip's stable id against selItems, never a
           rendered position — wrong-removal is structurally impossible. */
        var idx = -1;
        for (var i = 0; i < selItems.length; i++) { if (selItems[i].id === sid) { idx = i; break; } }
        if (idx !== -1) {
          selItems.splice(idx, 1);
          syncExposed();
          updateUI(panel);
        }
      }
      e.preventDefault();
    }
  });
}

function render(panel){
  var existing = panel.querySelector('[data-batida-candle-picker]');
  if (!existing) {
    var legacyText = panel.querySelector('.cross-product__input-text--candles');
    if (legacyText) {
      var legacyWrap = legacyText.closest('.cross-product__input-wrapper') || legacyText.parentElement;
      /* v60d-fix-3: use setProperty with 'important' flag — inline style:display:none gets overridden by an !important CSS rule on .cross-product__input-wrapper from v29's layout. */
      if (legacyWrap) legacyWrap.style.setProperty('display', 'none', 'important');
    }
    panel.insertAdjacentHTML('afterbegin', buildPickerHTML());
  }
  wirePicker(panel);
  updateUI(panel);
}

var __pickerRendered = false;
var __variantsPromise = null;

function init(){
  /* v60d-fix-2: short-circuit once rendered to avoid an infinite loop
     where updateUI() mutates DOM → MutationObserver fires → init → render → updateUI → ... */
  if (__pickerRendered) return true;
  var cp = findCandleCp();
  if (!cp) return false;
  var panel = findExpandedPanel(cp);
  if (!panel) return false;
  if (!variantMap) {
    /* 3.10 audit: one request, shared - every DOM change while it was loading started another fetch (26 per page) */
    if (!__variantsPromise) __variantsPromise = fetchVariants();
    __variantsPromise.then(function(data){
      if (__pickerRendered) return;
      if (!variantMap) { variantMap = buildVariantMap(data); window.__batidaCandleVariantMap = variantMap; }
      render(panel);
      __pickerRendered = true;
    }).catch(function(e){
      __variantsPromise = null;
      try { console.warn('[batida candle picker] variant fetch failed', e) } catch(_){}
    });
  } else {
    render(panel);
    __pickerRendered = true;
  }
  return true;
}

function tryInit(){
  init();
  [200, 600, 1500, 3500, 6000].forEach(function(ms){ setTimeout(function(){ if (!__pickerRendered) init() }, ms) });
  try {
    var mo = new MutationObserver(function(){
      if (__pickerRendered) { try { mo.disconnect() } catch(e){} return; }
      init();
    });
    mo.observe(document.body, {childList: true, subtree: true});
    setTimeout(function(){ try { mo.disconnect() } catch(e){} }, 10000);
  } catch(e){}
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', tryInit);
} else {
  tryInit();
}
})();
